export default "__VITE_ASSET__CQ1a1bLm__"